import { primaryBrandButtonSmall } from 'components/Globals/Base/Button/buttonStyles';
import styled, { keyframes } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getIcon } from 'styles/icons';
import { getBodyStyle, getColor, Theme } from 'styles/theme';

const slideup = keyframes`
    0% { transform: translateY(100%) }
    100% { transform: translateY(0) }
`;

export const Wrapper = styled.div<{ theme: Theme }>`
  width:100%;
  padding: 16px 20px;
  background-color: ${getColor('shadeBrandPrimary100')};
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 5;
  animation-name: ${slideup};
  animation-duration: 0.5s;
  will-change: transform;

  .sticky-cta-widget{
    display: flex;
    flex-direction: column;
    align-items: justify;
    padding:0;

    @media (${breakpoint.mdMin}) {
      align-items: center;
      flex-direction: row;
    }
  }

  .sticky-cta-info {
      ${getBodyStyle('graphikCond', { default: 'default' })};
      padding: 16px 0;

      @media (${breakpoint.mdMin}) {
        flex-grow: 1;
        padding: 0 20px;
      }
  }

  .sticky-cta-link {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    @media (${breakpoint.mdMin}) {
      margin-right: 52px;
    }
    @media (${breakpoint.xlMin}) {
      margin-right: 0px;
    }

    a{       
      ${primaryBrandButtonSmall}
      width: 100%;
      text-transform: uppercase;

      @media (${breakpoint.mdMin}) {
        width: 150px;
      }
    }
  }

  .sticky-cta-image{
    flex-grow: 0;
    margin: 0;
    padding: 0;
    max-width: 200px;
    min-width: 170px;
    max-height: 40px;
    min-height: 20px;
    img {
      max-height: 40px;
      min-height: 20px;
      // using !important for overwriting styling from next image
      width: auto !important;
      object-fit: contain !important;
    }
  }
`;

export const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  position: relative;

  @media (${breakpoint.xlMin}) {
    padding: 0 156px;
  }
`;

export const CloseButton = styled.button<{ theme: Theme }>`
  width: 16px;
  height: 16px;
  display: flex;
  position: absolute;
  top: 1px;
  right: 0;
  ${getIcon('svg-states')};

  &::before {
    ${getIcon('close-icon', { height: 12, width: 11 })};
  }

  @media (${breakpoint.xlMin}) {
    right: 102px;
  }

  @media (${breakpoint.mdMin}) {
    border-left: 1px solid ${getColor('borderSecondary')};;
    height: 36px;
    width: 36px;
    align-items: center;
    justify-content: center;
  }
`;
